// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AllocationKeyFromJSON, AllocationKeyToJSON, CommitmentCalculationFromJSON, CommitmentCalculationToJSON, EsgSustainabilityFromJSON, EsgSustainabilityToJSON, TenantModuleEnumFromJSON, TenantModuleEnumToJSON, UserActionsFromJSON, UserActionsToJSON, } from './';
export function TenantFromJSON(json) {
    return {
        'ticker': !exists(json, 'ticker') ? undefined : json['ticker'],
        'modules': !exists(json, 'modules') ? undefined : json['modules'].map(TenantModuleEnumFromJSON),
        'admin': !exists(json, 'admin') ? undefined : json['admin'],
        'cff': !exists(json, 'cff') ? undefined : json['cff'],
        'preqinShowConstituents': !exists(json, 'preqinShowConstituents') ? undefined : json['preqinShowConstituents'],
        'preqinShowWhatsNewBanner': !exists(json, 'preqinShowWhatsNewBanner') ? undefined : json['preqinShowWhatsNewBanner'],
        'preqinClient': !exists(json, 'preqinClient') ? undefined : json['preqinClient'],
        'insightResearchDownload': !exists(json, 'insightResearchDownload') ? undefined : json['insightResearchDownload'],
        'aladdinTickerPrefix': !exists(json, 'aladdinTickerPrefix') ? undefined : json['aladdinTickerPrefix'],
        'analyticsCopilot': !exists(json, 'analyticsCopilot') ? undefined : json['analyticsCopilot'],
        'hidePreviousVersionLink': !exists(json, 'hidePreviousVersionLink') ? undefined : json['hidePreviousVersionLink'],
        'navAdjustmentWihtoutIncome': !exists(json, 'navAdjustmentWihtoutIncome') ? undefined : json['navAdjustmentWihtoutIncome'],
        'insightAnalytics': !exists(json, 'insightAnalytics') ? undefined : json['insightAnalytics'],
        'insightResearch': !exists(json, 'insightResearch') ? undefined : json['insightResearch'],
        'commitmentPacing': !exists(json, 'commitmentPacing') ? undefined : json['commitmentPacing'],
        'options': !exists(json, 'options') ? undefined : json['options'],
        'allocationKey': !exists(json, 'allocationKey') ? undefined : AllocationKeyFromJSON(json['allocationKey']),
        'commitmentCalculation': !exists(json, 'commitmentCalculation') ? undefined : CommitmentCalculationFromJSON(json['commitmentCalculation']),
        'esgSustainability': !exists(json, 'esgSustainability') ? undefined : EsgSustainabilityFromJSON(json['esgSustainability']),
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
        'userActions': !exists(json, 'userActions') ? undefined : UserActionsFromJSON(json['userActions']),
        'clickthrough': !exists(json, 'clickthrough') ? undefined : json['clickthrough'],
        'dataImportExportAdministration': !exists(json, 'dataImportExportAdministration') ? undefined : json['dataImportExportAdministration'],
        'documentService': !exists(json, 'documentService') ? undefined : json['documentService'],
        'campaignDashboard': !exists(json, 'campaignDashboard') ? undefined : json['campaignDashboard'],
        'clickthroughStartDate': !exists(json, 'clickthroughStartDate') ? undefined : new Date(json['clickthroughStartDate']),
        'idd': !exists(json, 'idd') ? undefined : json['idd'],
        'marketMap': !exists(json, 'marketMap') ? undefined : json['marketMap'],
        'jCurves': !exists(json, 'jCurves') ? undefined : json['jCurves'],
        'customIndices': !exists(json, 'customIndices') ? undefined : json['customIndices'],
        'peerInvestorComparison': !exists(json, 'peerInvestorComparison') ? undefined : json['peerInvestorComparison'],
        'lightPortfolioAnalytics': !exists(json, 'lightPortfolioAnalytics') ? undefined : json['lightPortfolioAnalytics'],
        'oktaMigrated': !exists(json, 'oktaMigrated') ? undefined : json['oktaMigrated'],
        'vaultTenantId': !exists(json, 'vaultTenantId') ? undefined : json['vaultTenantId'],
        'useFundOpsModel': !exists(json, 'useFundOpsModel') ? undefined : json['useFundOpsModel'],
    };
}
export function TenantToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'ticker': value.ticker,
        'modules': value.modules === undefined ? undefined : value.modules.map(TenantModuleEnumToJSON),
        'admin': value.admin,
        'cff': value.cff,
        'preqinShowConstituents': value.preqinShowConstituents,
        'preqinShowWhatsNewBanner': value.preqinShowWhatsNewBanner,
        'preqinClient': value.preqinClient,
        'insightResearchDownload': value.insightResearchDownload,
        'aladdinTickerPrefix': value.aladdinTickerPrefix,
        'analyticsCopilot': value.analyticsCopilot,
        'hidePreviousVersionLink': value.hidePreviousVersionLink,
        'navAdjustmentWihtoutIncome': value.navAdjustmentWihtoutIncome,
        'insightAnalytics': value.insightAnalytics,
        'insightResearch': value.insightResearch,
        'commitmentPacing': value.commitmentPacing,
        'options': value.options,
        'allocationKey': AllocationKeyToJSON(value.allocationKey),
        'commitmentCalculation': CommitmentCalculationToJSON(value.commitmentCalculation),
        'esgSustainability': EsgSustainabilityToJSON(value.esgSustainability),
        'permissions': value.permissions,
        'userActions': UserActionsToJSON(value.userActions),
        'clickthrough': value.clickthrough,
        'dataImportExportAdministration': value.dataImportExportAdministration,
        'documentService': value.documentService,
        'campaignDashboard': value.campaignDashboard,
        'clickthroughStartDate': value.clickthroughStartDate === undefined ? undefined : value.clickthroughStartDate.toISOString(),
        'idd': value.idd,
        'marketMap': value.marketMap,
        'jCurves': value.jCurves,
        'customIndices': value.customIndices,
        'peerInvestorComparison': value.peerInvestorComparison,
        'lightPortfolioAnalytics': value.lightPortfolioAnalytics,
        'oktaMigrated': value.oktaMigrated,
        'vaultTenantId': value.vaultTenantId,
        'useFundOpsModel': value.useFundOpsModel,
    };
}
